<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-close="close" vm-size="large" :vm-buttons-hidden="true" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalVisible" :vm-title='title')
    .container__modal
      transition(name="slide-fade")
        .invoices(v-if="show")
          vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w=12)
            vm-col(vm-justify="center", vm-align="center", vm-w=3 class="gutters")
              b-form-group
                vm-input(autofocus :placeholder='$t("invoices.invoice_number")' :disabled="(remaining_amount === 0) && isAdd"  :danger="!$v.form.invoice_number" :danger-text="'invoice_number is required'" v-model="form.invoice_number" :label='$t("invoices.invoice_number")')
            vm-col(vm-justify="center", vm-align="center", vm-w=3 class="gutters")
              b-form-group
                vm-input(autofocus :placeholder='$t("invoices.amount")' :disabled="(remaining_amount === 0) && isAdd"  :danger="!$v.form.amount" :danger-text="'amount is required'" v-model="form.amount" :label='$t("invoices.amount")' @keyup="checkValue" @keypress="checkValue")
                span.string_amount {{ amount | currency }}
            vm-col(vm-justify="center", vm-align="center", vm-w=3 class="gutters")
              b-form-group
                vm-input(autofocus :danger-text="'invoiced date is required'" v-model="form.invoiced_date" type="date" :label='$t("invoices.invoiced_date")' @keyup="checkValue" @keypress="checkValue")
            vm-col(vm-justify="space-around", vm-align="center", vm-w=2 class="gutters" vm-type="flex")
              vm-button(icon="plus-outline" size="small" :disabled="$v.form.$invalid" @click="saveRecord" class="class") {{ string }}
              span.string_advise(color="warning" v-if="!need_imports") Ingrese importaciones
              vm-button(color="rgb(242, 19, 93)" size="small" @click="cancelEdit" v-if="!isAdd" class="class") Cancelar
          vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w=12)
            vm-col(vm-justify="center", vm-align="center", vm-w=3 class="gutters")
              h4.title Monto total de la venta
              h3.title_amount {{  total | currency }}
            vm-col(vm-justify="center", vm-align="center", vm-w=3 class="gutters")
              h4.title Monto total Facturado
              h3.title_amount {{  amountInvoices | currency }}
            vm-col(vm-justify="center", vm-align="center", vm-w=3 class="gutters")
              h4.title Monto restante por faturar
              h3.title_amount {{  remaining_amount | currency }}
            vm-col(vm-justify="center", vm-align="center", vm-w=3 class="gutters")
              h4.title Tipo de cambio
              h3.title_amount {{  currency  }}
          vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w=12)
            vm-col.card(vm-sm=12)
              vm-table(max-height="500px" :data="invoices")
                template(slot="header")
                  .d-flex.justify-content-between
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('invoices.' + column) }}
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                      .row
                        slot(v-if="column == 'invoice_number'") {{ data[indextr][column] }}
                        slot(v-if="column == 'amount'") {{ data[indextr][column] | currency }}
                        slot(v-if="column == 'created_at'") {{ data[indextr][column] | moment('DD MMMM YYYY') }}
                        slot(v-if="column == 'invoiced_date'") {{ data[indextr][column] | moment('DD MMMM YYYY') }}
                        .actions__wrapper(v-if="column == 'status'" )
                          vm-chip(:color="colorStatus(data[indextr]['status_display'])") {{data[indextr]['status_display']}}
                        .actions__wrapper(v-if="column == 'actions'")
                          vm-button(type="flat" icon="trash-2-outline" color="rgb(242, 19, 93)" @click="deleteInvoiceConfirm(data[indextr], tr)")
                          vm-button(type="flat" icon="edit-2-outline" color="#026481" @click="editInvoice(data[indextr])")
                          vm-button(type="flat" icon="plus-outline" color="#026481" @click="addPaymentsToInvoice(data[indextr])")
      transition(name="slide-fade")
        div(v-if="!show")
          .payments__wrapper
            vm-button(type="flat" icon="arrowhead-left-outline" color="#026481" @click="back")
            h2.invoice__information Agregar pago a la factura:
             span.invoice__number {{ invoice_number }}
            vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w=12 class="mt-3")
              vm-col(vm-justify="center" vm-align="center" vm-w=3 class="gutters")
                b-form-group
                  vm-input(autofocus :placeholder='$t("invoices_payments.amount_to_add")' :disabled="remaining_amount_payment === 0"  :danger="!$v.payment.amount" :danger-text="'amount is required'" v-model="payment.amount" :label='$t("invoices_payments.amount_to_add")' @keyup="checkValuePayment" @keypress="checkValuePayment")
                  span.string_amount {{ amount_total_payment | currency }}
              vm-col(vm-justify="center" vm-align="center" vm-w=3 class="gutters")
                b-form-group
                  vm-select(:label='$t("invoices_payments.payment_type")'  v-model="payment.payment_type" :disabled="remaining_amount_payment === 0")
                    vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in payment_types")
              vm-col(vm-justify="center" vm-align="center" vm-w=3 class="gutters")
                b-form-group
                  vm-date-picker(:placeholder='$t("strings.select_date")' type="date" width="100%" :label='$t("strings.payment_date")' @on-change="handleChange" :value="paymentDate" v-model="payment.payment_date" :disabled="remaining_amount_payment === 0")
              vm-col(vm-justify="space-around" vm-align="center" vm-w=2 class="gutters" vm-type="flex")
                vm-button(icon="plus-outline" size="small" :disabled="$v.payment.$invalid" @click="savePayment") Agregar
            vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w=12 class="mt-3 information__container")
              mini-loader(:visible="isLoading")
              vm-col(vm-justify="center" vm-align="center" vm-w=3 class="gutters")
                h4.title Monto total de la factura
                h3.title_amount {{ total_invoice | currency }}
              vm-col(vm-justify="center" vm-align="center" vm-w=3 class="gutters")
                h4.title Monto total pagado
                h3.title_amount {{ total_amount_payments | currency }}
              vm-col(vm-justify="center" vm-align="center" vm-w=3 class="gutters")
                h4.title Monto restante por pagar
                h3.title_amount {{ remaining_amount_payment | currency }}
              vm-col(vm-justify="center" vm-align="center" vm-w=3 class="gutters")
                h4.title Tipo de cambio
                h3.title_amount {{ currency }}
            vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w=12 class="mt-3")
              vm-col.card(vm-sm=12)
                vm-table(max-height="500px" :data="payments")
                  template(slot="header")
                    .d-flex.justify-content-between
                  template(slot="thead")
                    vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsPayments") {{ $t('invoices_payments.' + column) }}
                  template(slot-scope="{data}")
                    vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                      vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsPayments")
                        .row
                          slot(v-if="column == 'amount'") {{ data[indextr][column] | currency }}
                          slot(v-if="column == 'payment_type'") {{ paymentType(data[indextr]['payment_type']) }}
                          slot(v-if="column == 'payment_date'") {{ data[indextr][column] | moment('DD MMMM YYYY') }}
                          .actions__wrapper(v-if="column == 'actions'")
                            vm-button(type="flat" icon="trash-2-outline" color="rgb(242, 19, 93)" @click="deletePaymentConfirm(data[indextr])")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import MiniLoader from '@/components/additionals/MiniLoader.vue'
import { required, decimal } from 'vuelidate/lib/validators'
const { mapGetters, mapActions } = createNamespacedHelpers('Invoices')

export default {
  name: 'ModalSalesInvoices',
  components: {
    MiniLoader
  },
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    form: {},
    paymentDate: new Date(),
    payment: {
      payment_type: 'transfer',
      payment_date: new Date()
    },
    isLoading: false,
    columns: [
      'invoice_number',
      'amount',
      'created_at',
      'status',
      'invoiced_date',
      'actions'
    ],
    columnsPayments: [
      'amount',
      'payment_type',
      'payment_date',
      'actions'
    ],
    original_amount: '',
    isAdd: true,
    show: true,
    invoice_id: '',
    invoice: {},
    payment_types: [
      {
        text: 'Transferencia',
        value: 'transfer'
      },
      {
        text: 'Cheque',
        value: 'check'
      },
      {
        text: 'Efectivo',
        value: 'cash'
      },
      {
        text: 'Otro',
        value: 'other'
      }
    ]
  }),
  validations: {
    form: {
      invoice_number: {
        required
      },
      amount: {
        required,
        decimal
      }
    },
    payment: {
      amount: {
        required,
        decimal
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'invoices',
      'amountInvoices',
      'payments',
      'amountPayments'
    ]),
    title () {
      return this.$t('strings.invoices')
    },
    total () {
      if (this.sale.total) {
        return this.sale.total
      }
    },
    currency () {
      if (this.sale.currency.code) {
        return this.sale.currency.code
      }
    },
    remaining_amount () {
      if (this.sale) {
        return parseFloat(this.sale.total) - parseFloat(this.amountInvoices)
      }
    },
    remaining_amount_payment () {
      if (this.invoice.amount) {
        return parseFloat(this.invoice.amount) - parseFloat(this.amountPayments)
      }
    },
    amount () {
      return this.form.amount
    },
    string () {
      return this.isAdd ? this.$t('strings.add') : this.$t('strings.edit')
    },
    invoice_number () {
      if (this.invoice.invoice_number) {
        return this.invoice.invoice_number
      }
    },
    amount_total_payment () {
      if (this.payment.amount) {
        return this.payment.amount
      }
    },
    total_invoice () {
      if (this.invoice.amount) {
        return this.invoice.amount
      }
    },
    total_amount_payments () {
      if (this.amountPayments) {
        return this.amountPayments
      }
    },
    need_imports () {
      if (this.sale.purchase_orders[0] && this.sale.purchase_orders[0].supplier) {
        const regexM = new RegExp('m', 'i')
        const regexX = new RegExp('x', 'i')
        const isMx = regexM.test(this.sale.purchase_orders[0].supplier.country) && regexX.test(this.sale.purchase_orders[0].supplier.country)
        return isMx ? true : this.sale.imports.length > 0
      } else {
        return false
      }
    }
  },
  watch: {
    isModalVisible (flag) {
      if (flag) {
        this.loadRecords({ sale_id: this.sale.id }).then(() => {
          this.loadAmountInvoices({ sale_id: this.sale.id })
        })
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalVisible',
      'loadRecords',
      'loadAmountInvoices',
      'addRecord',
      'deleteRecord',
      'updateRecord',
      'actionSale',
      'loadPayments',
      'addPayment',
      'loadAmountPayments',
      'deletePayment'
    ]),
    async saveRecord () {
      if (this.need_imports) {
        if (this.isAdd) {
          this.form.sale_id = this.sale.id
          this.form.currency_id = this.sale.currency.id
          await this.addRecord({ sale_id: this.sale.id, data: this.form }).then(() => {
            this.form = {}
            this.loadAmountInvoices({ sale_id: this.sale.id }).then(() => {
              this.actionSale({ id: this.sale.id, action: 'invoiced' })
            })
          })
        } else {
          await this.updateRecord({ sale_id: this.sale.id, invoice_id: this.form.id, data: this.form }).then(() => {
            this.form = {}
            this.isAdd = true
            this.loadAmountInvoices({ sale_id: this.sale.id }).then(() => {
              this.actionSale({ id: this.sale.id, action: 'invoiced' })
            })
          })
        }
      } else {
        this.$vm.dialog({
          color: 'warning',
          title: 'Se requieren importaciones',
          text: 'Esta venta requiere ingresar importaciones antes de agregar facturas',
          accept: ''
        })
      }
    },
    async savePayment () {
      this.payment.invoice_id = this.invoice.id
      await this.addPayment({ invoice_id: this.invoice.id, data: this.payment }).then(() => {
        this.payment = {
          payment_type: 'transfer'
        }
        this.loadValues()
      })
    },
    editInvoice (record) {
      this.form = record
      this.original_amount = record.amount
      this.isAdd = false
    },
    addPaymentsToInvoice (record) {
      this.invoice.id = record.id
      this.invoice = record
      this.loadPayments({ invoice_id: this.invoice.id }).then(() => {
        this.loadAmountPayments({ invoice_id: this.invoice.id }).then(() => {
          this.show = false
        })
      })
    },
    cancelEdit () {
      this.form = {}
      this.isAdd = true
      this.original_amount = ''
    },
    checkValue () {
      if (this.isAdd) {
        if (this.form.amount >= 0 && this.form.amount !== '' && this.form.amount !== null) {
          if (parseFloat(this.form.amount) > parseFloat(this.remaining_amount)) this.form.amount = parseFloat(this.remaining_amount).toFixed(2)
        }
      } else {
        if (this.form.amount >= 0 && this.form.amount !== '' && this.form.amount !== null) {
          if (parseFloat(this.form.amount) > (parseFloat(this.remaining_amount) + parseFloat(this.original_amount))) this.form.amount = parseFloat(parseFloat(this.remaining_amount) + parseFloat(this.original_amount)).toFixed(2)
        }
      }
    },
    checkValuePayment () {
      if (this.payment.amount >= 0 && this.payment.amount !== '' && this.payment.amount !== null) {
        if (parseFloat(this.payment.amount) > parseFloat(this.remaining_amount_payment)) this.payment.amount = parseFloat(this.remaining_amount_payment).toFixed(2)
      }
    },
    deleteInvoiceConfirm (invoice) {
      let t = this
      this.auxDeleteInvoice = () => {
        t.deleteRecord({ sale_id: this.sale.id, invoice: invoice }).then(() => {
          this.loadAmountInvoices({ sale_id: this.sale.id }).then(() => {
            this.actionSale({ id: this.sale.id, action: 'uninvoiced' })
          })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.invoice'), attribute: this.$t(invoice.invoice_number) }),
        accept: this.auxDeleteInvoice
      })
    },
    deletePaymentConfirm (payment) {
      let t = this
      this.auxDeletePayment = () => {
        t.deletePayment({ invoice_id: this.invoice.id, payment_id: payment.id, payment: payment }).then(() => {
          this.loadValues()
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.payment'), attribute: this.$t(payment.amount) }),
        accept: this.auxDeletePayment
      })
    },
    loadValues () {
      this.isLoading = true
      setTimeout(() => {
        this.loadAmountPayments({ invoice_id: this.invoice.id }).then(() => {
          this.actionSale({ id: this.sale.id, action: 'paid' }).then(() => {
            this.isLoading = false
          })
        })
      }, 2000)
    },
    colorStatus (status) {
      switch (status) {
        case 'Pendiente':
          return '#026481'
        case 'Pagado':
          return 'rgb(23, 201, 100)'
      }
    },
    back () {
      this.payment = {
        payment_type: 'transfer'
      }
      this.show = true
      this.loadRecords({ sale_id: this.sale.id }).then(() => {
        this.loadAmountInvoices({ sale_id: this.sale.id })
      })
    },
    close () {
      this.payment = {
        payment_type: 'transfer'
      }
      this.show = true
      this.setModalVisible(false)
    },
    handleChange (date) {
      this.paymentDate = date
    },
    paymentType (code) {
      return this.payment_types.find(e => e.value === code).text
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  text-align: center;
}

.title_amount {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.string_amount {
  position: absolute;
}
.string_advise {
  position: absolute;
  bottom: 20rem;
}
/*Helpers*/

.gutters {
  padding: 10px;
}
.slide-fade-enter-active {
  transition: all 1s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.slide-fade-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: translateX(100px);
  opacity: 0;
}

.table {
  padding-left: 0 !important;
  .vm-table-text {
    padding-left: 0 !important;
  }
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.container__modal {
  height: 400px;
  overflow-y: scroll;
  position: relative;
}

.invoice__information {
  text-align: center;
  span {
    color: #026481;
  }
}

.information__container {
  position: relative;
}
</style>
